
import { defineComponent } from 'vue';
import Sidebar from './components/Sidebar.vue';

export default defineComponent({
  name: "App",
  components: {
    Sidebar,
  },
  data() {
    return {
      isDarkModeOn: false
    }
  },
  methods: {
    toggleTheme(isDarkModeOn: boolean) {
      this.isDarkModeOn = isDarkModeOn;
    }
  }
});
